import { forgotPwdStrings } from '../../data/static/strings'
import { testProps } from '../../util/util'
import { ResetFormInput } from './ResetFormInput'

import * as Yup from 'yup'
import { getString } from '../../util/languageStrings'
import { Colors } from '../../util/util'

const passwordValidation = Yup.string()
  .min(8, 'Password Must Contain 8 Characters')
  .required('Password Must Contain 8 Characters')
  .test('it contain atleast one uppercase', 'Password must contain atleast one Uppercase character', (value) => {
    if (!value) {
      return false
    }
    return /[A-Z]/.test(value)
  })
  .test('it contain atleast one lowercase', 'Password must contain atleast one Lowercase character', (value) => {
    if (!value) {
      return false
    }
    return /[a-z]/.test(value)
  })
  .test('it contain atleast one number', 'Password must contain atleast one Number', (value) => {
    if (!value) {
      return false
    }
    return /[0-9]/.test(value)
  })
  .test(
    'it contain atleast one special case Character',
    'Password must contain atleast one special case Character (Allowed: !@#$%^&*)',
    (value) => {
      if (!value) {
        return false
      }
      return /[!@#$%^&*]/.test(value)
    },
  )

export const resetForm = (rightComp, showPassword, selectedAppLanguage): any => {
  return [
    {
      formItems: [
        {
          fieldName: 'password',
          ComponentName: ResetFormInput,
          height: 48,
          labelFontSize: 14,
          label: getString(selectedAppLanguage, 'password'),
          validationSchema: passwordValidation,
          ...testProps('pwd-input'),
          rightComponent: rightComp,
          displayName: 'Password',
          secureTextEntry: showPassword ? false : true,
          autoFocus: false,
          selectionColor: Colors.PRIMARY,
          selectedAppLanguage: selectedAppLanguage,
          maxLength:35,
        },
      ],
    },
  ]
}

export const pwdStrengthCbData = [
  {
    id: '1',
    value: forgotPwdStrings.eightCharacters,
  },
  {
    id: '2',
    value: forgotPwdStrings.oneLowerCaseLetter,
  },
  {
    id: '3',
    value: forgotPwdStrings.oneCapitalLetter,
  },
  {
    id: '4',
    value: forgotPwdStrings.oneSpecialCharacter,
  },
  {
    id: '5',
    value: forgotPwdStrings.oneDigit,
  },
  {
    id: '6',
    value: forgotPwdStrings.noSequentialDigit,
  },
  {
    id: '7',
    value: forgotPwdStrings.noRepeatingDigit,
  },
  {
    id: '8',
    value: forgotPwdStrings.noSpace,
  },
]
